/**
 * Automy.Core.Enums.Reporting.Identity.ReportPlatform
 * JSON `reportPlatform` (integer 1–3). Not the engine.
 */
export default Object.freeze({
  Web: 1, // web
  Mobile: 2, // mobile
  WebMobile: 3, // web-mobile
});
